import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanoService } from '@core/services/plano.service';
import Swal from 'sweetalert2';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoInterface } from 'app/module/pedido-interface';
import { ContratoService } from '@core/services/contrato.service';
import { ContratoInterface } from 'app/module/contrato-interface';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { ChipService } from '@core/services/chip.service';
import { ContratoChipInterface } from 'app/module/contrato-chip-interface';
import { ContratoChipService } from '@core/services/contrato-chip.service';
import { ContratoItemService } from '@core/services/contrato-item.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}


@Component({
	selector: 'app-form-contrato',
	templateUrl: './form-contrato.component.html',
	styleUrls: ['./form-contrato.component.scss'],
	providers: [
		{ provide: NgbDateAdapter, useClass: CustomAdapter },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
	],
})
export class FormContratoComponent implements OnInit {
	@ViewChild('cadastroForm') cadastroForm: NgForm;
	pedido: PedidoInterface;
	apiData;
	sidebarToggleRef = false;
	tipoItem;
	indexItem;
	tipoItemSelecionado = [];
	contentHeader: object;
	planos;
	selectedCliente: any = null;
	termoPesquisa: string = '';
	carregando: boolean = false;
	clientes;
	valorTotal: number = 0;
	erro: boolean = false;
	loading: boolean;
	arrayPost = []
	temp: any;
	starting: boolean = false;
	contratoInterface: ContratoInterface;
	selectedDate: NgbDateStruct;
	formattedDate: string;
	dataSelecionada: NgbDateStruct;
	dataFormatada: string;
	ColumnMode = ColumnMode;
	spinnerImportar = false;
	separador = "\n";
	bipados = "";
	modoVinculacao = 1;
	nao_vinculados: Array<any> | any = [];
	vinculados: Array<any> | any = [];
	nao_vinculados_show = false;
	chipsVinculadosContrato: Array<any> | any = [];
	itensContrato: Array<any> | any = [];
	loadingIndicatorChipsVinculados = false;

	private _unsubscribeAll: Subject<any>;

	constructor(
		private chipService: ChipService,
		private ngbDateParserFormatter: NgbDateParserFormatter,
		private planoService: PlanoService,
		private modalService: NgbModal,
		private _router: Router,
		private route: ActivatedRoute,
		private contratoService: ContratoService,
		private contratoChipService: ContratoChipService,
		private contratoItemService: ContratoItemService) {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	async ngOnInit() {
		this.starting = true;

		this.contratoInterface = {
			id_contrato: this.route.snapshot.params.id,
			id_tipo: 1,
			id_status: 1,
			id_plano: null,
			id_pedido: null,
			id_cliente: 0,
			num_contrato: null,
			dt_fidelidade: null,
			dt_contrato: null,
			dt_insert: null
		}

		this.planoService.get().subscribe(
			(res) => {
				this.starting = false;
				this.planos = res
				if (this.contratoInterface.id_contrato) {
					this.starting = true;
					this.contratoService.getOne(this.contratoInterface.id_contrato).subscribe(
						async (res) => {
							this.contratoInterface = {
								id_contrato: this.route.snapshot.params.id,
								id_tipo: res[0].id_tipo,
								id_status: res[0].id_status,
								id_plano: res[0].id_plano,
								id_pedido: res[0].id_pedido,
								id_cliente: res[0].id_cliente,
								num_contrato: res[0].num_contrato,
								dt_fidelidade: moment((res[0].dt_fidelidade).substring(0, 10), 'YYYY-MM-DD').format('DD-MM-YYYY'),
								dt_contrato: moment((res[0].dt_contrato).substring(0, 10), 'YYYY-MM-DD').format('DD-MM-YYYY'),
								dt_insert: res[0].dt_insert
							}
							this.contratoItemService.findOneByContratoId(this.contratoInterface.id_contrato).subscribe(
								(resContratoItens) => {
									if (resContratoItens.length > 0) this.itensContrato = resContratoItens;
								},
								(err) => {
									console.log(err);

								}
							)
							this.starting = false;

						},
						(err) => {
							console.log(err);
							this.starting = false;
						}
					);
					this.contratoChipService.getByContratoId(this.contratoInterface.id_contrato).subscribe(
						(res) => {
							this.chipsVinculadosContrato = res
							this.starting = false;
						},
						(err) => {
							console.log(err);
							this.starting = false;

						}
					)


				}
			},
			(err) => {
				console.log(err);
				this.starting = false;
			}
		)


		this.contentHeader = {
			headerTitle: this.contratoInterface.id_contrato ? "Gerenciar Contrato" : "Novo Contrato",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Contrato",
						isLink: false,
					},
					{
						name: this.contratoInterface.id_contrato ? "Gerenciar" : "Novo",
						isLink: false,
					},
				],
			},
		};
	}

	ngAfterContentChecked() {
		this.nao_vinculados = [...this.nao_vinculados];
		this.vinculados = [...this.vinculados];
	}

	convertToDatepickerFormat(dateString) {
		const [year, month, day] = dateString.split('-');

		const dateStruct: NgbDateStruct = {
			year: parseInt(year, 10),
			month: parseInt(month, 10),
			day: parseInt(day, 10)
		};

		return dateStruct;
	}

	onDateChange(dp: any) {
		this.formattedDate = this.ngbDateParserFormatter.format(this.selectedDate);
		dp.close();
	}

	ngOnChanges(changes) {
		// changes.prop contains the old and the new value...
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.planos = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	valorFilter(event) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.valor.toLowerCase().indexOf(val) !== -1 || !val && d.percentual.toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.planos = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	fecharResultadoVinculacao(){
		this.chipsVinculadosContrato = [];
		this.loadingIndicatorChipsVinculados = true;
		this.bipados = "";
		this.nao_vinculados = [];
		this.vinculados = [];
		this.nao_vinculados_show = false;
		this.contratoChipService.getByContratoItemId(this.indexItem).subscribe(
			(res) => {
				this.chipsVinculadosContrato = res
				this.loadingIndicatorChipsVinculados = false;
			},
			(err) => {
				console.log(err);
				this.loadingIndicatorChipsVinculados = false;
			}
		)
	}

	modalOpen(modalBasic, item) {
		this.chipsVinculadosContrato = [];
		this.indexItem = item;
		this.loadingIndicatorChipsVinculados = true;
		this.modalService.open(modalBasic, {
			windowClass: 'modal',
			size: 'xl',
			centered: true
		});
		this.bipados = "";
		this.nao_vinculados = [];
		this.vinculados = [];
		this.nao_vinculados_show = false;
		this.contratoChipService.getByContratoItemId(this.indexItem).subscribe(
			(res) => {
				this.chipsVinculadosContrato = res
				this.loadingIndicatorChipsVinculados = false;
			},
			(err) => {
				console.log(err);
				this.loadingIndicatorChipsVinculados = false;
			}
		)
	}

	msgErroInterno() {
		this.starting = false;
		this.loading = false;
		Swal.fire({
			title: "Erro!",
			text: "Ocorreu um erro interno.",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	erroPreenchimento() {
		this.loading = false;
		Swal.fire({
			title: "Preencha todos os campos corretamente!",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	submitForm(cadastroForm) {
		this.contratoInterface.dt_contrato = moment(this.contratoInterface.dt_contrato, 'DD-MM-YYYY').format('YYYY-MM-DD');
		this.contratoInterface.dt_fidelidade = moment(this.contratoInterface.dt_fidelidade, 'DD-MM-YYYY').format('YYYY-MM-DD');
		if (this.contratoInterface.dt_fidelidade == null) {
			this.erro = true;
			this.erroPreenchimento()
		}
		if (this.contratoInterface.dt_contrato == null) {
			this.erro = true;
			this.erroPreenchimento()
		}
		// if (this.contratoInterface.id_plano == null) {
		// 	this.erro = true;
		// 	this.erroPreenchimento()
		// }
		if (!this.contratoInterface.id_contrato && !this.erro) {
			// POST
			this.contratoService.post(this.contratoInterface).subscribe(
				(res) => {
					if (res.id_contrato) {
						this.loading = false;
						Swal.fire({
							title: "Contrato cadastrado!",
							text: "O item foi cadastrado com sucesso.",
							icon: "success",
							confirmButtonText: "Confirmar",
							confirmButtonColor: '#161D31',
						}).then(() => {
							this._router.navigate(['contrato/gerenciar/' + res.id_contrato])
						});
					} else {
						this.msgErroInterno()
					}
				},
				(error) => {
					console.log(error);
					this.msgErroInterno()
				}
			);
		} else {
			// PUT
		}
	}

	importarCsv(file) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja importar as informações inseridas?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.isConfirmed) {
				this.spinnerImportar = true;
				const formData = new FormData();
				formData.append('file', file);
			}
		})
	}

	EnviarBips() {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja vincular os chips inseridos?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.isConfirmed) {
				this.spinnerImportar = true;
				let bips = {
					bipados: this.bipados,
					separador: this.separador,
					id_contrato: this.contratoInterface.id_contrato,
					id_contrato_item: this.indexItem,
					id_tipo: this.contratoInterface.id_tipo
				}
				this.chipService.importarBips(bips).subscribe(
					(result) => {
						result.forEach(element => {
							if (element[0].erro == "1") {
								this.nao_vinculados.push({ status: element[0].iccId + ' - ' + element[0].msg })
								this.erro = true
								this.spinnerImportar = false;
							} else {
								this.vinculados.push({ status: element[0].iccId + ' - ' + element[0].msg })
								this.spinnerImportar = false;
							}
						});

						this.contratoChipService.getByContratoItemId(this.indexItem).subscribe(
							(res) => {
								this.chipsVinculadosContrato = res
								this.loadingIndicatorChipsVinculados = false;
							},
							(err) => {
								console.log(err);
								this.loadingIndicatorChipsVinculados = false;
							}
						)
						if (this.erro) {
							Swal.fire({
								title: "Erro ao importar!",
								text: "Houve um erro ao importar um ou mais chips, confira na tabela.",
								icon: "error",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this.nao_vinculados_show = true;
								this.starting = false;
								this.spinnerImportar = false;
							});
						}
						if (!this.erro) {

							Swal.fire({
								title: "Chips importados!",
								text: "Os chips foram importados com sucesso.",
								icon: "success",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this.spinnerImportar = false;
							});
						}
						this.contratoChipService.getByContratoId(this.contratoInterface.id_contrato).subscribe(
							(res) => {
								this.chipsVinculadosContrato = res
								this.starting = false;
							},
							(err) => {
								console.log(err);
								this.starting = false;

							}
						)
						this.starting = false;
					},
					(error) => {
						this.spinnerImportar = false;
						console.log(error);
						this.msgErroInterno()
					}
				)
			}
		})
	}

}
